import { __read, __spread } from "tslib";
import { DirectPurchaseService } from '../../../services/DirectPurchaseService/DirectPurchaseService';
export var createCheckoutExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    return ({
        handleDirectPurchase: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = new DirectPurchaseService({ siteStore: context.siteStore, origin: origin })).handleDirectPurchase.apply(_a, __spread(args));
        },
    });
};
//# sourceMappingURL=wixcode.checkout.js.map